import { render, staticRenderFns } from "./i-wysiwyg-service.vue?vue&type=template&id=226055d6&scoped=true&"
import script from "./i-wysiwyg-service.vue?vue&type=script&lang=js&"
export * from "./i-wysiwyg-service.vue?vue&type=script&lang=js&"
import style0 from "./i-wysiwyg-service.vue?vue&type=style&index=0&id=226055d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226055d6",
  null
  
)

export default component.exports